import {LeadFitScore} from 'nutshell-graphql-types';
import type {LeadFitScore as LeadFitScoreType} from 'nutshell-graphql-types';

import {scoreMap} from './consts';

export function getLeadFitVariant(score: LeadFitScoreType): string {
    return scoreMap[score] || 'possible';
}

export function isLeadFitUnknown(score: LeadFitScoreType): boolean {
    return score === LeadFitScore.UNKNOWN;
}
